<form [formGroup]="form">
  <div class="row">
    <div class="col">
      <frm-anlage-facility-information-page-template-select
        formControlName="templateID"
      ></frm-anlage-facility-information-page-template-select>
    </div>
  </div>
</form>

<div style="height: 400px; overflow-y: auto">
  <mat-list dense>
    @for (facility of facilityInfos; track facility) {
      <mat-list-item>
        <span matLine>{{ facility.facilityNoCombined }}</span>
        <span matLine>{{ facility.label }} - {{ facility.standort }}</span>
        <button mat-icon-button (click)="onFacilityRemove(facility)">
          <mat-icon>close</mat-icon>
        </button>
      </mat-list-item>
    }
  </mat-list>
</div>
